import { Route } from '@angular/router';
import { MainLayoutComponent } from './layout/app-layout/main-layout/main-layout.component';
import { AuthGuard } from '@core/guard/auth.guard';
import { AuthLayoutComponent } from './layout/app-layout/auth-layout/auth-layout.component';
import { Page404Component } from './authentication/page404/page404.component';
import { HomeComponent } from './home/home.component';
import { AccueilComponent } from './accueil/accueil/accueil.component';
import { dashboardGuard } from '@core/guard/dashboard.guard';
import { serviceCaisseGuard } from '@core/guard/service-caisse.guard';
import { GedComponent } from './ged/ged.component';
import { gedGuard } from '@core/guard/ged.guard';
import { restaurantAccessGuard } from '@core/guard/restaurant-access.guard';
import { boutiqueAccessGuard } from '@core/guard/boutique-access.guard';
import { ManuelUtilisationComponent } from './manuel-utilisation/manuel-utilisation.component';
import { PlanningComponent } from './planning/planning.component';
import { planningGuard } from '@core/guard/planning.guard';
export const APP_ROUTE: Route[] = [
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: '/authentication/signin', pathMatch: 'full' },

      {
        path: 'dashboard',
        loadChildren: () =>
          import('./dashboard/dashboard.routes').then((m) => m.DASHBOARD_ROUTE),
        canActivate: [AuthGuard, dashboardGuard],
      },
      {
        path: 'accueil',
        component: AccueilComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'service-caisse',
        // component: ServiceCaisseComponent,
        canActivate: [AuthGuard, serviceCaisseGuard],
        loadChildren: () =>
          import('./service-caisse/service-caisse.routes').then(
            (m) => m.RESTO_ROUTE
          ),
      },
      {
        path: 'home',
        component: HomeComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'planning',
        component: PlanningComponent,
        canActivate: [AuthGuard, planningGuard],
      },

      {
        path: 'accueil',
        loadChildren: () =>
          import('./accueil/accueil.routes').then((m) => m.ACCUEIL_ROUTE),
      },
      {
        path: 'stock',
        loadChildren: () =>
          import('./stock/stock.routes').then((m) => m.STOCK_ROUTE),
      },
      {
        path: 'restaurant',
        canActivate: [AuthGuard, restaurantAccessGuard],
        loadChildren: () =>
          import('./restaurant/restaurant.routes').then((m) => m.RESTO_ROUTE),
      },
      {
        path: 'boutique',
        canActivate: [AuthGuard, boutiqueAccessGuard],
        loadChildren: () =>
          import('./boutique/boutique.routes').then((m) => m.BOUTIQUE_ROUTE),
      },
      {
        path: 'location-espace',
        loadChildren: () =>
          import('./location-espace/location-espace.routes').then(
            (m) => m.RESTO_ROUTE
          ),
      },
      {
        path: 'ged',
        component: GedComponent,
        canActivate: [AuthGuard, gedGuard],
      },
      {
        path: 'tresorerie',
        loadChildren: () =>
          import('./tresorerie/tresorerie.routes').then((m) => m.STOCK_ROUTE),
      },
      {
        path: 'administration',
        loadChildren: () =>
          import('./administration/administration.routes').then(
            (m) => m.ADMINISTRATION_ROUTE
          ),
      },
      {
        path: 'parametre',
        loadChildren: () =>
          import('./parametre/parametre.routes').then((m) => m.PARAMETRE_ROUTE),
      },
      {
        path: 'audit',
        loadChildren: () =>
          import('./audit/audit.routes').then((m) => m.PARAMETRE_ROUTE),
      },
      {
        path: 'relation-client',
        loadChildren: () =>
          import('./relation-client/relation-client.routes').then(
            (m) => m.ROUTES
          ),
      },
      {
        path: 'maintenance',
        loadChildren: () =>
          import('./maintenance/maintenance.routes').then(
            (m) => m.MAINTENANCE_ROUTE
          ),
      },
      {
        path: 'etat',
        loadChildren: () =>
          import('./etat/etat.routes').then((m) => m.ETAT_ROUTE),
      },
      {
        path: 'manuel-utilisation',
        component: ManuelUtilisationComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: 'authentication',
    component: AuthLayoutComponent,
    loadChildren: () =>
      import('./authentication/auth.routes').then((m) => m.AUTH_ROUTE),
  },
  { path: '**', component: Page404Component },
];
